// src/components/StudentLoanInput.jsx
import React from 'react';
import { Box, FormControl, InputLabel, Select, MenuItem, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';


const StudentLoanInput = ({ studentLoanPlan, onStudentLoanPlanChange }) => {
  const handleChange = (event) => {
    onStudentLoanPlanChange(event.target.value);
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="h6" gutterBottom>
        Student Loan
      </Typography>
      <FormControl fullWidth>
        <InputLabel id="student-loan-label">Student Loan Plan</InputLabel>
        <Select
          labelId="student-loan-label"
          value={studentLoanPlan}
          label="Student Loan Plan"
          onChange={handleChange}
        >
          <MenuItem value="none">None</MenuItem>
          <MenuItem value="plan1">Plan 1</MenuItem>
          <MenuItem value="plan2">Plan 2</MenuItem>
          <MenuItem value="plan4">Plan 4</MenuItem>
          <MenuItem value="postgraduate">Postgraduate</MenuItem>
        </Select>
      </FormControl>

      <Typography variant="caption" sx={{ display: 'block', mb: 2 }}>
        <Link component={RouterLink} to="/about-the-salary-calculator#student-loan" color="primary" underline="hover">
          Learn more about how student loan contributions affect your take-home pay.
        </Link>
      </Typography>
    </Box>
  );
};

export default StudentLoanInput;
